<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="promo"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.is_monthly`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_monthly"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_monthly"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.is_session`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_session"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_session"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.is_class`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_class"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_class"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
      </datatable>
      </div>
    </div>
    <form-action ref="form" module="promo" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="promo"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Paket", route: "" },
      { title: "Promo" }
    ]);
  },
  data() {
    return {
      title: "Promo",
      url: "promo/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Slug",
          value: "slug",
          sortable: true,
          searchable: true
        },
        {
          text: "Nama",
          value: "name",
          sortable: true,
          searchable: true
        },
        {
          text: "Deskripsi",
          value: "description",
          sortable: true,
          searchable: true
        },
        {
          text: "Persentase",
          value: "percentage",
          sortable: true,
          searchable: true
        },
        {
          text: "Berlaku untuk Paket Bulanan",
          value: "is_monthly",
          sortable: false,
          searchable: false,
        },
        {
          text: "Berlaku untuk Paket Sesi",
          value: "is_session",
          sortable: false,
          searchable: false,
        },
        {
          text: "Berlaku untuk Paket Kelas",
          value: "is_class",
          sortable: false,
          searchable: false,
        },

      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
